





























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetTems, GetOptions } from "@/request/common";
@Component({
  components: {},
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private options: any = [];
  private props: any = { multiple: true };
  private currentData: any = {};
  private ifShowImgBox: any = false;
  private goDetail(item: any) {
    this.currentData = item;
    this.ifShowImgBox = true;
    this.$router.push({
      path: "/main/shixun/study-detail",
      query: {
        id: item.question_template_id,
      },
    });
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private get user() {
    return this.$store.state.user;
  }

  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      类别: "面",
      答案: this.filters.type,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("sheListFilter", JSON.stringify(this.filters));
    GetTems(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getOptions() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        类别: "面",
      },
    };
    GetOptions(this, params, loading)
      .then((res: any) => {
        loading.close();
        let arr: any = [];
        res.forEach((element: any) => {
          if (
            element.type == "单选" ||
            element.type == "多选" ||
            element.type == "判断"
          ) {
            let obj: any = {
              label: element.title,
              value: element.title,
              children: [],
            };
            element.options.forEach((ele: any) => {
              obj.children.push(ele);
            });
            arr.push(obj);
          }
        });
        this.options = arr;
        console.log(arr);
      })
      .catch(() => {
        loading.close();
      });
  }

  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("sheListFilter")) {
      this.filters = JSON.parse(localStorage.getItem("sheListFilter") as any);
    }
    this.getList();
    this.getOptions();
  }
}
